import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AirportPicker from "@/components/AirportPicker";

function defaultDropoff() {
  const d = new Date(); d.setDate(d.getDate() + 7); d.setHours(6, 0, 0, 0);
  return d.toISOString().slice(0, 16);
}
function defaultPickup() {
  const d = new Date(); d.setDate(d.getDate() + 14); d.setHours(22, 0, 0, 0);
  return d.toISOString().slice(0, 16);
}

export default function SearchWidget({ initial = {}, floating = true }) {
  const nav = useNavigate();
  const [airport, setAirport] = useState(initial.airport || "LHR");
  const [dropoff, setDropoff] = useState(initial.dropoff || defaultDropoff());
  const [pickup, setPickup] = useState(initial.pickup || defaultPickup());
  const [promo, setPromo] = useState(initial.promo || "");
  const [err, setErr] = useState("");

  const submit = (e) => {
    e.preventDefault();
    setErr("");
    if (!airport) return setErr("Choose an airport");
    if (new Date(pickup) <= new Date(dropoff)) return setErr("Pick-up must be after drop-off");
    const q = new URLSearchParams({ airport, dropoff, pickup, promo }).toString();
    nav(`/search?${q}`);
  };

  return (
    <form
      onSubmit={submit}
      data-testid="search-widget"
      className={`bg-white rounded-2xl border border-slate-200 p-5 md:p-6 grid grid-cols-1 md:grid-cols-12 gap-5 items-end ${floating ? "shadow-[0_20px_60px_rgba(11,27,61,0.15)]" : ""}`}
    >
      <div className="md:col-span-4">
        <AirportPicker value={airport} onChange={setAirport} />
      </div>
      <div className="md:col-span-3">
        <label className="text-[11px] font-bold tracking-[0.18em] uppercase text-slate-500">Drop-off</label>
        <input type="datetime-local" value={dropoff} onChange={(e) => setDropoff(e.target.value)}
          className="mt-1 w-full border-b border-slate-200 focus:border-[var(--fpn-navy)] py-2 outline-none text-sm"
          data-testid="dropoff-input" />
      </div>
      <div className="md:col-span-3">
        <label className="text-[11px] font-bold tracking-[0.18em] uppercase text-slate-500">Pick-up</label>
        <input type="datetime-local" value={pickup} onChange={(e) => setPickup(e.target.value)}
          className="mt-1 w-full border-b border-slate-200 focus:border-[var(--fpn-navy)] py-2 outline-none text-sm"
          data-testid="pickup-input" />
      </div>
      <div className="md:col-span-2">
        <button type="submit" data-testid="search-submit-button"
          className="btn-amber w-full rounded-full py-3 px-4 text-sm">
          Search Parking
        </button>
      </div>
      <div className="md:col-span-12 flex flex-wrap items-center gap-4">
        <input type="text" placeholder="Promo code (optional)" value={promo} onChange={(e) => setPromo(e.target.value)}
          className="text-sm border-b border-slate-200 focus:border-[var(--fpn-navy)] py-2 outline-none"
          data-testid="promo-input" />
        {err && <div className="text-xs text-red-600 font-medium" data-testid="search-error">{err}</div>}
      </div>
    </form>
  );
}
